import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainEditGroup(data) {
  return maintainRequest({
    url: `/device/maintenanceMan/device_group/editGroup`,
    method: "post",
    data,
  });
}
